import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { useEffect, useState } from "react";
import axios from "axios";
import { urlAPI } from "../../../config/config";
import { ITNS, ITNSFormValues } from "../../../interface/tns";
import TNSLabelField from "./TNSLabelField";
import TNSMonthFields from "./TNSMonthFields";
import { convertMonthsToOldFormat } from "../../function/convertToOldFormat/convertToOldFormat";

const validationSchema = yup.object({
  label: yup.string().required("Le libellé est obligatoire"),
});

const AddUpdateTNS = ({
  tnsId,
  handleSubmit,
  forecastId,
  version,
  setOpenModal,
  monthList,
  setShowConfirmDialog
}: {
  tnsId?: string;
  handleSubmit: Function;
  forecastId?: string,
  version?: number,
  setOpenModal: Function,
  monthList: { name: string, field: string }[],
  setShowConfirmDialog: Function
}) => {
  let dispatch = useDispatch();

  let token = useSelector((state: RootState) => state.user.token) as string;

  const [tns, setTns] = useState<ITNS>();
  const [error, setError] = useState("");

  const getTNS = async () => {
    if (!token || !tnsId) {
      return;
    }
    try {
      const syncResponse = await axios.get(`${urlAPI}/forecast/tns/${tnsId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );


      const updatedMessageFormated = convertMonthsToOldFormat(syncResponse.data.message);

      setTns(updatedMessageFormated);

    } catch (error: any) {
      const errorMessage = error.message || error.response?.data?.message || "Erreur lors de la mise à jour des salariés.";
      setError(errorMessage);
      setTimeout(() => setError(""), 4000);
    }
  };



  useEffect(() => {
    getTNS();
  }, []);


  const formik = useFormik({
    initialValues: {
      label: tns ? tns.label : "",
      months: tns ? tns.months
        : monthList.reduce((acc: any, item: any) => {
          acc[item.field] = 0;
          return acc;
        }, {}),
    },
    validationSchema: validationSchema,
    onSubmit: (values: ITNSFormValues) => {
      handleSubmit(token, values, forecastId, version!, setOpenModal, dispatch, setError, tnsId);
    },
    enableReinitialize: true,
  });

  return (
    <Box component="form" onSubmit={formik.handleSubmit} sx={{ mt: 1, width: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", padding: "20px" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", minHeight: "600px" }}>
        <TNSLabelField tns={tns} formik={formik} />
        <TNSMonthFields formik={formik} monthList={monthList} />
      </Box>
      <Box sx={{ display: "flex", columnGap: "200px" }}>
        <Button type="button" variant="contained" sx={{ mt: 3, mb: 2 }} onClick={() => { setShowConfirmDialog(true) }}>Annuler</Button>
        <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }}>Enregistrer</Button>
      </Box>
    </Box>
  )
}

export default AddUpdateTNS;